import { createElement } from 'react';
import './index.scss';
const ColorfulAvatar = props => {
    const { size, type, icon, imgUrl, title, des, ...otherProps } = props;
    const prefixCls = 'au-avatar';
    const avatarClass = [type, size,].filter(_ => !!_).map(_ => `${prefixCls}-${_}`).join(' ');
    const _otherProps = otherProps || {};
    const renderTxt = () => {
        if (!title && !des) {
            return '';
        }
        return (createElement("div", { className: "au-avatar-extra" },
            title && createElement("div", { className: "au-avatar-extra-title" }, title),
            des && createElement("div", { className: "au-avatar-extra-des" }, des)));
    };
    return (createElement("div", { className: `${prefixCls} ${avatarClass}`, ..._otherProps },
        imgUrl ? (createElement("div", { className: "au-avatar-img" },
            createElement("label", { className: "au-image-img-bg" },
                createElement("img", { className: 'au-image-img', src: imgUrl })))) :
            (createElement("div", { className: "au-avatar-ico" },
                createElement("label", { className: "au-avatar-ico-bg" },
                    createElement("i", { className: icon || "icon-solid-user" })))),
        renderTxt()));
};
ColorfulAvatar.displayName = 'ColorfulAvatar';
export default ColorfulAvatar;
